/** Separate, versioned permission for same-company brand marketing.
 * Existing TruWe-only permission must never be re-labelled with this version.
 * Neither tracking permission nor health-service permission implies this scope.
 */
export const COMPANY_MARKETING_NOTICE_VERSION = "omkara-brands-2026-10-04";
export const COMPANY_MARKETING_CONTROLLER = "OMKARA NUTRACEUTICALS PRIVATE LIMITED";
export const COMPANY_MARKETING_COPY =
  "I agree to receive optional offers and product updates from OMKARA NUTRACEUTICALS PRIVATE LIMITED about TruWe and all current and future brands operated by that company, only through the channels I select below. This is not required to reserve or buy. I can withdraw any channel or all company-brand marketing at any time. A materially different marketing purpose requires a new choice.";
export const COMPANY_MARKETING_CHANNELS = ["whatsapp", "email", "sms", "phone", "push"] as const;

export type CompanyMarketingChannel = "whatsapp" | "email" | "sms" | "phone" | "push";
export interface CompanyMarketingEvidence {
  currentStatus: "granted" | "denied" | "withdrawn" | "unknown";
  channel: CompanyMarketingChannel;
  noticeVersion: string;
  explicit: boolean;
  controller: string;
  usesHealthData: boolean;
}

/** Sender contract: supply trusted persisted evidence, never request-body flags.
 * This is an additional gate, not a replacement for suppression, identity,
 * channel rules, quiet hours, frequency limits or delivery eligibility.
 */
export function canUseCompanyBrandMarketing(
  evidence: CompanyMarketingEvidence,
  requestedChannel: CompanyMarketingChannel,
  receivingBrandController: string,
): boolean {
  return evidence.currentStatus === "granted"
    && evidence.explicit === true
    && evidence.noticeVersion === COMPANY_MARKETING_NOTICE_VERSION
    && evidence.channel === requestedChannel
    && evidence.controller === COMPANY_MARKETING_CONTROLLER
    && receivingBrandController === COMPANY_MARKETING_CONTROLLER
    && evidence.usesHealthData === false;
}
